import { PensionCompany } from "../model";

/** Logic related to settings: Insurances, pension etc. */
export class SettingsLogic {

  /**
   * Returns pension number for test account
   * @param company The company enumerations.
   * Only the most common pension companies are supported.
   */
   public static getPensionNumberForTest(company: PensionCompany): string | null {

    const checksumLetters = "0123456789ABCDEFHJKLMNPRSTUVWXY";
    const contract = "1111111";
    const calculateNumber = (company) => company + "-" + contract + checksumLetters[parseInt(company + contract, 10) % 31];

    switch (company) {
      case PensionCompany.Varma:
        return "55-1111111S";
      case PensionCompany.Elo:
        return "54-11111114";
      case PensionCompany.Ilmarinen:
        return "46-1111111Y";
      case PensionCompany.Veritas:
        return "56-1111111D";
      case PensionCompany.Apteekkien:
        return "80009-1111N";
      case PensionCompany.Verso:
        return "80008-11113";
      case PensionCompany.KevaMunicipal:
        return calculateNumber("20");
      case PensionCompany.KevaAland:
        return calculateNumber("24");
      case PensionCompany.KevaChurch:
        return calculateNumber("25");
      case PensionCompany.KevaKela:
        return calculateNumber("29");
      case PensionCompany.KevaState:
        return calculateNumber("30");
      case PensionCompany.Valio:
        return "80001-11111";
      default:
        return null;
    }
  }
}
